module.exports = __webpack_public_path__ + "static/media/ucon3.bede665c.JPG";